import { apiPostRequest } from '@/shared/api/corsProxy';

export interface IContactResponse {
  firstname: string;
  phone: string;
  domain: string;
  mail: string | null;
  privacy_policy: boolean;
  created_at: string;
}

export const handleSendReq = async (
  name: string,
  phone: string,
  agreement: boolean,
  domain?: string
) => {
  const sendReq = {
    firstname: name,
    phone: phone,
    mail: null,
    created_at: new Date().toISOString(),
    domain: domain || 'https://krasota.agency',
    privacy_policy: agreement || true,
  };
  const res = await apiPostRequest<IContactResponse>('/contact', sendReq);
  return res;
};
